export default "__VITE_ASSET__CTve76fH__"